export const SET_TAGS = 'SET_TAGS';
export const ADD_TAGS = 'ADD_TAGS';
export const DELETE_TAG = 'DELETE_TAG';